module.exports = __webpack_public_path__ + "img/faro-room-3.d2bb0130.jpg";